import axios from "axios"
import _ from "lodash"
import {
  API_URL,
  API_URL_STORES,
  API_URL_CUSTOMERS,
  API_URL_PRICES,
  API_URL_CUSTOMERS_NO_PROXY,
  API_URL_INVENTORY,
  API_URL_ROLES,
  API_URL_LOC_HIERARCHY,
  API_URL_PRODUCT,
  API_URL_CUSTOMERS_COMMON,
  getDynamicAPI_URL,
  getConfigAddonHeaders,
  SAMPLE_FILE_TEMPLATE,
  getFlagCheckPathSAAS,
  getAddOnHeaders,
  getAddOnHeadersGlobal,
} from "../../utils/url"
import { axiosConfig } from "../apiHeaderService"
import UserService from "../UserService"
import jwt_decode from "jwt-decode"
const { location = {} } = window || {}

const headerAxios = axios.create()

export const headerAxiosziptastic = axios.create()

const applyForcedRealmIdHeader = (config = {}) => {
  const headers = config.headers || {}
  const forcedRealmId =
    headers["x-dg-realm-id"] ||
    headers["X-DG-Realm-Id"] ||
    headers["X-Dg-Realm-Id"]
  if (forcedRealmId) {
    headers["realm-id"] = forcedRealmId
    delete headers["x-dg-realm-id"]
    delete headers["X-DG-Realm-Id"]
    delete headers["X-Dg-Realm-Id"]
  }

  const forcedTenantId =
    headers["x-dg-tenant-id"] ||
    headers["X-DG-Tenant-Id"] ||
    headers["X-Dg-Tenant-Id"]
  if (forcedTenantId) {
    headers["tenant-id"] = forcedTenantId
    delete headers["x-dg-tenant-id"]
    delete headers["X-DG-Tenant-Id"]
    delete headers["X-Dg-Tenant-Id"]
  }

  return config
}

headerAxios.interceptors.request.use(
  async function (config) {
    const { isSaasView = false } = config || {}
    if (UserService.isLoggedIn()) {
      if (UserService.isAuthExpired() === true) {
        const myData = await UserService.updateRefreshToken()
        if (myData === true) {
          let mydataToken = UserService.getToken((res) => {
            return res
          })
          localStorage.setItem("token", mydataToken)
          if (!config.headers["X-Tenant-ID"]) {
            getAddOnHeadersGlobal(
              config,
              isSaasView ? "saas-view" : "normal-view"
            )
          }

          config.headers["Authorization"] = "Bearer " + mydataToken
          getConfigAddonHeaders(config)
          applyForcedRealmIdHeader(config)
          return Promise.resolve(config)
        } else {
          localStorage.clear()
          UserService.doLogout()
        }
      } else {
        if (!config.headers["X-Tenant-ID"]) {
          getAddOnHeadersGlobal(
            config,
            isSaasView ? "saas-view" : "normal-view"
          )
        }
        config.headers["Authorization"] =
          localStorage.getItem("token") === null
            ? ""
            : "Bearer " + localStorage.getItem("token")
        getConfigAddonHeaders(config)
        applyForcedRealmIdHeader(config)
        return Promise.resolve(config)
      }
    } else {
      localStorage.clear()
      UserService.doLogout()
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)
const headerAxiosDRealm = axios.create()

headerAxiosDRealm.interceptors.request.use(
  async function (config) {
    const { isSaasView = false } = config || {}
    if (UserService.isLoggedIn()) {
      if (UserService.isAuthExpired() === true) {
        const myData = await UserService.updateRefreshToken()
        if (myData === true) {
          let mydataToken = UserService.getToken((res) => {
            return res
          })
          localStorage.setItem("token", mydataToken)
          if (!config.headers["X-Tenant-ID"]) {
            let tenantId =
              localStorage.getItem("tenantId") === null
                ? ""
                : localStorage.getItem("tenantId")
            config.headers["X-Tenant-ID"] = tenantId
            config.headers["X-KC-Realm-ID"] = localStorage.getItem(
              "X-KC-Realm-ID"
            )
            config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
            getAddOnHeadersGlobal(
              config,
              isSaasView ? "saas-view" : "normal-view"
            )
          }

          config.headers["Authorization"] = "Bearer " + mydataToken
          getConfigAddonHeaders(config)

          return Promise.resolve(config)
        } else {
          localStorage.clear()
          UserService.doLogout()
        }
      } else {
        if (!config.headers["X-Tenant-ID"]) {
          let tenantId =
            localStorage.getItem("tenantId") === null
              ? ""
              : localStorage.getItem("tenantId")
          config.headers["X-Tenant-ID"] = tenantId
          config.headers["X-KC-Realm-ID"] = localStorage.getItem(
            "X-KC-Realm-ID"
          )
          config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
          getAddOnHeadersGlobal(
            config,
            isSaasView ? "saas-view" : "normal-view"
          )
        }
        config.headers["Authorization"] =
          localStorage.getItem("token") === null
            ? ""
            : "Bearer " + localStorage.getItem("token")
        getConfigAddonHeaders(config)
        return Promise.resolve(config)
      }
    } else {
      localStorage.clear()
      UserService.doLogout()
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)

headerAxiosziptastic.interceptors.request.use(
  async function (config) {
    if (UserService.isLoggedIn()) {
      if (UserService.isAuthExpired() === true) {
        const myData = await UserService.updateRefreshToken()
        if (myData === true) {
          let mydataToken = UserService.getToken((res) => {
            return res
          })
          config.headers["x-Key"] = "b08143470b1d74904b91b90446dc5fe14543c87b"
          return Promise.resolve(config)
        } else {
          localStorage.clear()
          UserService.doLogout()
        }
      } else {
        config.headers["x-Key"] = "b08143470b1d74904b91b90446dc5fe14543c87b"
        return Promise.resolve(config)
      }
    } else {
      localStorage.clear()
      UserService.doLogout()
    }
  },
  function (error) {
    return Promise.reject(error)
  }
)

let apiEndpoint = process.env.REACT_APP_API_ENDPOINT
apiEndpoint = getDynamicAPI_URL()

const API_BASE_URL = apiEndpoint
const KC_API_BASE_URL = apiEndpoint

export { headerAxios, API_BASE_URL, KC_API_BASE_URL, headerAxiosDRealm }

export const doGetFetchAPI = (
  props,
  isLocal = false,
  headersObject = {},
  HITL_FLAG = false
) => {
  const { END_POINTS = "", prefixUrl = "" } = props || {}
  const API_BASE_URLs = API_BASE_URL.replace(":3013", "")
  let apiURL = API_BASE_URLs.length > 0 ? API_BASE_URLs : prefixUrl

  let convert = apiURL + END_POINTS
  if (isLocal) {
    convert = convert.replace(
      "https://apidev.digitmart.ai/portal",
      "http://192.168.11.156:8004"
    )
    convert = convert.replace("gondola/", "")
  }

  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  let lcAPI = HITL_FLAG ? headerAxiosDRealm : headerAxios
  return lcAPI.get(convert, { headers: headersObject, ...options })
}

export const doPostFetchAPI = (props, config = {}, isLocal = false) => {
  const { END_POINTS = "", prefixUrl = "", body = {} } = props || {}
  const API_BASE_URLs = API_BASE_URL.replace(":3013", "")
  let apiURL = API_BASE_URLs.length > 0 ? API_BASE_URLs : prefixUrl
  let convert = apiURL + END_POINTS
  if (isLocal) {
    convert = convert.replace(
      "https://apidev.digitmart.ai/portal",
      "http://192.168.11.156:8004"
    )
    convert = convert.replace("gondola/", "")
  }
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  return headerAxios.post(convert, body, { ...options, ...config })
}
export const doPostFetchDReamAPI = (props, config = {}, isLocal = false) => {
  const { END_POINTS = "", prefixUrl = "", body = {} } = props || {}
  const API_BASE_URLs = API_BASE_URL.replace(":3013", "")
  let apiURL = API_BASE_URLs.length > 0 ? API_BASE_URLs : prefixUrl
  let convert = apiURL + END_POINTS
  if (isLocal) {
    convert = convert.replace(
      "https://apidev.digitmart.ai/portal",
      "http://192.168.11.156:8004"
    )
    convert = convert.replace("gondola/", "")
  }
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  return headerAxiosDRealm.post(convert, body, { ...options, ...config })
}
export const doPutFetchAPI = (props, config = {}, isLocal = false) => {
  const { END_POINTS = "", prefixUrl = "", body = {} } = props || {}
  const API_BASE_URLs = API_BASE_URL.replace(":3013", "")
  let apiURL = API_BASE_URLs.length > 0 ? API_BASE_URLs : prefixUrl
  let convert = apiURL + END_POINTS
  if (isLocal) {
    convert = convert.replace(
      "https://apidev.digitmart.ai/portal",
      "http://192.168.11.156:8004"
    )
    convert = convert.replace("gondola/", "")
  }
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  return headerAxios.put(convert, body, { ...options, ...config })
}
export const getCommonData = async (END_POINTS) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(API_URL + END_POINTS, { ...options })
    return response
  } catch (error) {
    return error
  }
}

export const getCommonDatabody = async (
  END_POINTS,
  bodyData = {},
  config = {}
) => {
  // console.log("headerAxios", headerAxios)
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(API_URL + END_POINTS, bodyData, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}

export const fetchCommonData = async (
  END_POINTS,
  bodyData = {},
  config = {}
) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(
      API_URL + END_POINTS,
      bodyData,
      { ...options, ...config }
    )
    return response
  } catch (error) {
    return error
  }
}

export const deleteRecords = async (END_POINTS, config = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(API_URL + END_POINTS, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}

export const fetchCommonDataCustom = async (
  END_POINTS,
  bodyData = {},
  config = {}
) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(END_POINTS, bodyData, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}
export const putCommonDataCustom = async (
  END_POINTS,
  bodyData = {},
  config = {}
) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.put(END_POINTS, bodyData, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}
export const getCommonDataCustom = async (
  END_POINTS,
  bodyData = {},
  config = {}
) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(END_POINTS, bodyData, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}
export const deleteCommonDataCustom = async (
  END_POINTS,
  bodyData = {},
  config = {}
) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(END_POINTS, bodyData, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}
export const fetchStoreDashBoardData = async (END_POINTS, bodyData = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(API_URL + END_POINTS, bodyData, options)

    return response
  } catch (error) {
    return error
  }
}
export const fetchStoreDashTenantData = async (END_POINTS, bodyData = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(API_URL + END_POINTS, bodyData, options)
    return response
  } catch (error) {
    return error
  }
}

export const fetchCommonRoleData = async (
  END_POINTS,
  bodyData = {},
  headerData = {}
) => {
  /* let response = await headerAxios.post(API_URL + END_POINTS, body, {
      headers: {
        "Realm-ID": realmId,
        "Tenant-ID": tenantId,
        Host: localStorage.getItem("X-KC-Host"),
      }, */
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(
      API_URL_ROLES + END_POINTS,
      bodyData,
      { ...options, ...headerData }
    )
    return response
  } catch (error) {
    return error
  }
}

export const getCommonRoleData = async (END_POINTS, config = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(API_URL_ROLES + END_POINTS, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}

export const putCommonRoleData = async (
  END_POINTS,
  bodyData = {},
  config = {}
) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.put(
      API_URL_ROLES + END_POINTS,
      bodyData,
      { ...options, ...config }
    )
    return response
  } catch (error) {
    return error
  }
}

export const fetchStoreCommonData = async (END_POINTS, bodyData = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  //BK
  try {
    let response = await headerAxios.post(
      API_URL_STORES + END_POINTS,
      bodyData,
      options
    )
    return response
  } catch (error) {
    return error
  }
}
export const fetchStoreTaxData = async (END_POINTS, bodyData = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(API_URL_STORES + END_POINTS, bodyData, options)
    return response
  } catch (error) {
    return error
  }
}
export const putStoreCommonData = async (END_POINTS, bodyData = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.put(API_URL_STORES + END_POINTS, bodyData, options)
    return response
  } catch (error) {
    return error
  }
}

export const getStoreCommonData = async (END_POINTS, propsKit) => {
  const {
    isSaasEnable = false,
    realmId = "",
    tenantId,
    isSaasView: passedIsSaasView,
  } = propsKit || {}
  let options =
    passedIsSaasView !== undefined
      ? { isSaasView: passedIsSaasView }
      : isSaasEnable
        ? {
            isSaasView: localStorage
              .getItem("sourceRole")
              .includes("SaaS-Site-Admin")
              ? localStorage.getItem("X-KC-Realm-ID") ===
                localStorage.getItem("defaultRealmIdSelect")
                ? false
                : true
              : false,
          }
        : {}
  try {
    let response = await headerAxios.get(API_URL_STORES + END_POINTS, {
      ...options,
      headers: {
        "realm-id": realmId,
        'tenant-id':tenantId,
      },
    })
    return response
  } catch (error) {
    return error
  }
}

export const getStoreWithHeadersData = async (
  END_POINTS,
  headers = {},
  url = API_URL_STORES
) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  return headerAxios.get(url + END_POINTS, {
    ...options,
    ...headers,
  })
}

export const fetchCustomerCommonData = async (
  END_POINTS,
  bodyData = {},
  urlDomain = API_URL_CUSTOMERS_COMMON
) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(
      API_URL_CUSTOMERS_COMMON + END_POINTS,
      bodyData,
      options
    )
    return response
  } catch (error) {
    return error
  }
}

export const getCustomerCommonData = async (END_POINTS) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(API_URL_CUSTOMERS_COMMON + END_POINTS, { ...options })
    return response
  } catch (error) {
    return error
  }
}

export const putCustomerCommonData = async (END_POINTS, bodyData, id = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.put(
      API_URL_CUSTOMERS_COMMON + END_POINTS + "/" + id,
      bodyData,
      options
    )
    return response
  } catch (error) {
    return error
  }
}

export const postProductCommonData = async (
  END_POINTS,
  body = {},
  innerProps
) => {
  const { isSaasEnable = false } = innerProps || {}

  let options = isSaasEnable
    ? {
      isSaasView: localStorage
        .getItem("sourceRole")
        .includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    : {}
  try {
    let response = await headerAxios.post(
      API_URL_PRODUCT + END_POINTS,
      body,
      options
    )
    return response
  } catch (error) {
    return error
  }
}

export const getProductCommonData = async (END_POINTS) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(API_URL_PRODUCT + END_POINTS, { ...options })
    return response
  } catch (error) {
    return error
  }
}

export const patchProductCommonData = async (END_POINTS, body = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.patch(API_URL_PRODUCT + END_POINTS, body, options)
    return response
  } catch (error) {
    return error
  }
}

export const fetchInventoryCommonData = async (END_POINTS, bodyData = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(
      API_URL_INVENTORY + END_POINTS,
      bodyData,
      options
    )
    return response
  } catch (error) {
    return error
  }
}

export const putInventoryCommonData = async (END_POINTS, bodyData) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.put(
      API_URL_INVENTORY + END_POINTS,
      bodyData,
      options
    )
    return response
  } catch (error) {
    return error
  }
}

export const getAllCustomers = async (END_POINTS, page, limit, filter) => {
  try {
    const storesLink =
      filter === ""
        ? API_URL_CUSTOMERS + END_POINTS + "?page=" + page + "&limit=" + limit
        : API_URL_CUSTOMERS +
        END_POINTS +
        "?" +
        filter +
        "&page=" +
        page +
        "&limit=" +
        limit
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await headerAxios.get(storesLink, { ...options })

    return response
  } catch (error) {
    return { status: "failed" }
  }
}

export const getAllInventory = async (END_POINTS, page, limit = 10, filter) => {
  try {
    const inventoryLink =
      filter === ""
        ? API_URL_INVENTORY + END_POINTS + "?page=" + page + "&limit=" + limit
        : API_URL_INVENTORY +
        END_POINTS +
        "/?" +
        filter +
        "&page=" +
        page +
        "&limit=" +
        limit
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await headerAxios.get(inventoryLink, { ...options })
    return response
  } catch (error) {
    return { status: "failed" }
  }
}
export const getAllProducts = async (END_POINTS, page, limit, filter) => {
  try {
    const productLink =
      filter === ""
        ? API_URL_PRODUCT + END_POINTS + "?page=" + page + "&limit=" + limit
        : API_URL_PRODUCT +
        END_POINTS +
        "?" +
        filter +
        "&page" +
        page +
        "&limit" +
        limit
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await headerAxios.get(productLink, { ...options })
    return response
  } catch (error) {
    return { status: "failed" }
  }
}

export const getAllPrices = async (END_POINTS, page, limit, filter) => {
  try {
    const storesLink =
      filter === ""
        ? API_URL_PRICES + END_POINTS + "?page=" + page + "&limit=" + limit
        : API_URL_PRICES +
        END_POINTS +
        "?" +
        filter +
        "&page=" +
        page +
        "&limit=" +
        limit
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await headerAxios.get(storesLink, { ...options })
    return response
  } catch (error) {
    return { status: "failed" }
  }
}
export const getElasticSearch = async (END_POINTS = "") => {
  try {
    const storesLink = API_URL_PRICES + END_POINTS
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await headerAxios.get(storesLink, { ...options })
    return response
  } catch (error) {
    return { status: "failed" }
  }
}

export const addNewAddress = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(API_URL_CUSTOMERS + END_POINTS, body, options)
    return response
  } catch (error) {
    return error
  }
}

export const editAddress = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(API_URL_CUSTOMERS + END_POINTS, body, options)
    return response
  } catch (error) {
    return error
  }
}

export const postCommonDataConfig = async (
  END_POINTS,
  body,
  realmId,
  tenantId
) => {
  try {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    if (options?.isSaasView) {
      options["admin"] = "saas"
    }
    let response = await headerAxios.post(API_URL + END_POINTS, body,
      {
        headers: {
          "X-KC-Realm-ID": localStorage.getItem("sourceRole")?.includes("SaaS")
            ? localStorage.getItem("selectedDefaultRealmValue") || "NILL"
            : realmId,
          "X-Tenant-ID": localStorage.getItem("sourceRole")?.includes("SaaS")
            ? localStorage.getItem("selectedDefaultTenantId") || "NILL"
            : tenantId,
          // "X-KC-Realm-ID": realmId,
          //   "X-Tenant-ID": tenantId,
          "realm-id": localStorage.getItem("defaultRealmIdSelect"),
          "X-KC-Host": localStorage.getItem("X-KC-Host"),
          ...options
        },

      })
    return response
  } catch (error) {
    return error
  }
}

export const postCommonDataConfigCustom = async (
  END_POINTS,
  body,
  realmId,
  tenantId
) => {
  try {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let tenantIdData = tenantId ? { "Tenant-ID": tenantId } : {}
    let response = await headerAxios.post(API_URL + END_POINTS, body, {
      headers: {
        // "Realm-ID": realmId,
        ...tenantIdData,
        Host: localStorage.getItem("X-KC-Host"),
      },
      ...options,
    })
    return response
  } catch (error) {
    return error
  }
}

export const postCommonData = async (END_POINTS, body, config = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(API_URL + END_POINTS, body, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}

export const putCommonData = async (END_POINTS, body, config = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.put(API_URL + END_POINTS, body, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}

export const updateCommonData = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.patch(API_URL + END_POINTS, body, options)
    return response
  } catch (error) {
    return error
  }
}

export const deleteCommonData = async (END_POINTS, config = {}) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(API_URL + END_POINTS, { ...options, ...config })
    return response
  } catch (error) {
    return error
  }
}

export const deleteMultipleCommonData = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(API_URL + END_POINTS, {
      data: body,
      ...options,
    })
    return response
  } catch (error) {
    return error
  }
}
export const getAllLocation = async (page, limit, filter) => {
  try {
    const storesLink =
      filter === ""
        ? `${API_BASE_URL}/api/stores/stores?page=` + page + "&limit=" + limit
        : `${API_BASE_URL}/api/stores/stores?` +
        filter +
        "&page=" +
        page +
        "&limit=" +
        limit

    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await headerAxios.get(storesLink, { ...options })
    return response
  } catch (error) {
    return error
  }
}

export const getAllLocationGroups = async (page, limit, filter) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(
      `${API_BASE_URL}/api/stores/getallgroups`,
      { ...options }
    )
    return response
  } catch (error) {
    return error
  }
}

export const getAllStates = async () => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    const statesLink = `${API_BASE_URL}/api/stores/getAllRegions`
    let response = await headerAxios.get(statesLink, { ...options })
    return response
  } catch (error) {
    return error
  }
}

export const postCommonDataURL = async (URL_END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(URL_END_POINTS, body, options)
    return response
  } catch (error) {
    return error
  }
}

export const getCommonDataUrlOnId = async (END_POINTS) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(END_POINTS, { ...options })
    return response
  } catch (error) {
    return error
  }
}

export const updateCommonDataURLOnId = async (URL_END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.patch(URL_END_POINTS, body, options)
    return response
  } catch (error) {
    return error
  }
}

export const deleteCommonDataUrlOnId = async (END_POINTS) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(END_POINTS, { ...options })
    return response
  } catch (error) {
    return error
  }
}

export const deleteMultipleStores = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(API_URL_STORES + END_POINTS, {
      data: body,
      ...options,
    })
    return response
  } catch (error) {
    return error
  }
}

export const deleteMultipleProducts = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(API_URL_PRODUCT + END_POINTS, {
      data: body,
      ...options,
    })
    return response
  } catch (error) {
    return error
  }
}
export const deleteMultipleOffers = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(
      API_URL_PRODUCT + END_POINTS,

      {
        headers: {
          "user-email": localStorage.getItem("userEmail"),
          "tenant-id": localStorage.getItem("tenantId"),
        },
        data: body,
        ...options,
      }
    )
    return response
  } catch (error) {
    return error
  }
}

export const deleteMultipleCustomers = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(
      API_URL_CUSTOMERS_NO_PROXY + END_POINTS,
      {
        data: body,
        ...options,
      }
    )
    return response
  } catch (error) {
    return error
  }
}
export const deleteMultipleInventories = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(API_URL_INVENTORY + END_POINTS, {
      data: body,
      ...options,
    })
    return response
  } catch (error) {
    return error
  }
}
export const deleteMultiplePrice = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(END_POINTS, {
      data: body,
      ...options,
    })
    return response
  } catch (error) {
    return error
  }
}

export const createNewInventory = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(API_URL_INVENTORY + END_POINTS, body, options)
    return response
  } catch (error) {
    return error
  }
}
export const getCommonInvontery = async (END_POINTS) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(END_POINTS, { ...options })
    return response
  } catch (error) {
    return error
  }
}
export const createNewPrice = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.post(API_URL_PRICES + END_POINTS, body, options)
    return response
  } catch (error) {
    return error
  }
}

export const getLocationHierarchy = async () => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(API_URL_LOC_HIERARCHY, { ...options })
    return response
  } catch (error) {
    return error
  }
}

export const getAllCities = async () => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.get(
      `${API_BASE_URL}/api/stores/getAllCities`,
      { ...options }
    )
    return response
  } catch (error) {
    return error
  }
}

export const deleteMultipleAttibutes = async (END_POINTS, body) => {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  try {
    let response = await headerAxios.delete(API_BASE_URL + END_POINTS, {
      data: body,
      ...options,
    })
    return response
  } catch (error) {
    return error
  }
}

export const bulkUploadProducts = async (END_POINTS, body) => {
  try {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    let response = await headerAxios.post(API_BASE_URL + END_POINTS, body, {
      ...options,
    })
    return response
  } catch (error) {
    return error
  }
}

export const fetchZipcodeDetails = async (
  zipcode,
  countryCode = localStorage.getItem("country_code") || "US"
) => {
  let url = "https://zip.getziptastic.com"
  let urlVersion = "v3"
  try {
    let response = await headerAxiosziptastic.get(
      `${url}/${urlVersion}/${countryCode}/${zipcode}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const getBulkUpload_SampleTemplate = async (
  moduleName,
  langCode,
  locationId
) => {
  //   try {
  //     let response = await headerAxios.get(
  //       API_BASE_URL + SAMPLE_FILE_TEMPLATE + `/${moduleName}/${langCode}`,
  //       {
  //         headers: {
  //           // Accept: "application/json",
  //           // "Content-Type": "application/json",
  //           "location-id": locationId,
  //         },
  //       }
  //     )
  //     return response
  //   } catch (error) {
  //     return error
  //   }
}
